// Core
import React, { useEffect, useCallback, useState } from 'react';
import { Box, Button, Flex, Grid, Text, Image, useColorMode, useDisclosure} from '@chakra-ui/react';
import { NavLink } from 'react-router-dom';

// Assets
import { formatDateWithSuffix, colorUserSubLayout } from 'services/Utils';
import profileSub from 'assets/img/profile-sub.png';
import emptyPlan from 'assets/img/empty-plan.png';

// Components
import AttentionModal from 'components/Modals/AttentionModal';

const ActivePlan = (props) => { 
  const { userData, handleCancelMembership, goToCustomerPortal, isLoadingCustomerPortal } = props;

  const { colorMode } = useColorMode();
  const isDark = colorMode === 'dark';

  const { isOpen: isOpenAttention, onClose: onCloseAttention, onOpen: onOpenAttention } = useDisclosure();

  return (
	<>
		<Box p="16px 16px 16px 12px" borderRadius="16px 16px 0 0" position="relative" overflow="hidden">
			<Image 
				zIndex="2"
				opacity="0.2"
				src={userData?.activePlan?.image || emptyPlan} alt="Profile" 
				right="-10%" top="-40%" objectFit="cover" position="absolute" w="400px" h="400px"/>

			<Box position="absolute" top="0" left="0"
				zIndex="1"
				bg={() => colorUserSubLayout(userData?.activePlan?.type)}
				w="100%" h="100%"/>

			<Flex gap="12px" justifyContent="space-between" zIndex="1" position="relative" zIndex="3">
				<Flex gap="12px" zIndex="1" position="relative" zIndex="3" w="100%" alignItems="center">
					<Box
					  w="64px"
					  h="64px"
					  boxShadow="0px 2.56px 9.344px 0px rgba(0, 0, 0, 0.25)"
					  borderRadius="12px">
					  <Image src={userData?.activePlan?.image || emptyPlan} alt="Plan" />
					</Box>

					<Text variant="title-lg" w={{base: '50%'}} mt="-2px" fontSize="24px" fontStyle="normal" fontWeight="800" color="white">
					    {userData?.activePlan?.name}
					</Text>
				</Flex>

				{ userData?.activePlan && (
				  <>
				    { userData?.activePlan?.canceledAt === null ? (
				      <Text
				        variant="title-md"
				        h="26px"
				        w="110px"
				        textAlign="center"
				        padding="3px 9px"
				        borderRadius="100px"
				        cursor="pointer"
				        onClick={onOpenAttention}
				        bg={ isDark ? '#0F1426' : 'white'}>Cancel</Text>
				    ) : userData?.activePlan?.canceledAt ? (
			        <Button
			          variant="title-md"
			          h="26px"
			          w="110px"
			          padding="3px 9px"
			          borderRadius="100px"
			          cursor="pointer"
			          onClick={goToCustomerPortal}
         				isLoading={isLoadingCustomerPortal}
			          bg={ isDark ? '#0F1426' : 'white'}>Renew</Button>
				    ) : (
				    	<a href="https://lmctgiveaway.com/loyalty-membership">
				        <Text
				          variant="title-md"
				          h="26px"
				          w="110px"
				          textAlign="center"
				          padding="3px 9px"
				          borderRadius="100px"
				          cursor="pointer"
				          bg={ isDark ? '#0F1426' : 'white'}>Choose</Text>
				      </a>
				  	)}
				  </>
				)}
			</Flex>

			<Box zIndex="3" position="relative" mt="8px">
			    { userData?.activePlan &&
			    	<Text variant="title-lg" fontSize="24px" fontStyle="normal" fontWeight="700" color="white">
					    ${userData?.activePlan?.price / 100} <span style={{fontSize: '17px', marginLeft: '-5px'}}>/{userData?.activePlan?.paymentType === 'monthly' ? 'month' : 'year' }</span>
					</Text>

			    }
				<Text variant="title-lg" fontSize="15px" color="white">{ userData?.activePlan?.canceledAt === null ? 'Next payment on' : 'Subscription Canceled'} </Text>
				{ userData?.activePlan?.canceledAt === null ? (
				    <Text variant="title-lg" fontSize="15px" color="white">{formatDateWithSuffix(userData?.activePlan?.nextBillingDate)} for {userData?.activePlan?.price / 100}$</Text>
				) : (
				    <Text variant="title-lg" fontSize="15px" color="white">No upcoming payments. Your plan features remain available until {formatDateWithSuffix(userData?.activePlan?.nextBillingDate)}</Text>
				)}
			</Box>
		</Box>

		<AttentionModal
		  handle={handleCancelMembership}
		  isOpen={isOpenAttention}
		  onClose={onCloseAttention}
		  title="Cancel Subscription?"
		  description="Are you sure you want to cancel? Some features will no longer be available."
		/>
	</>
  );
};

export default ActivePlan;